import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UploadExcelFacade } from '@mode/dataset/excel/contract';
import { UploadExcelService } from './upload-excel.service';
import { UploadExcelDialogService } from './upload-excel-dialog.service';

@NgModule({
  imports: [CommonModule],
  providers: [UploadExcelDialogService, { provide: UploadExcelFacade, useClass: UploadExcelService }],
})
export class DatasetExcelDomainModule {}
